import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';
import { getAllData, getCities } from './Service';

class Store {
  @observable loading = true;
  @observable data = null;
  @observable filterType = 'All';
  @observable filterCaseStage = -1;
  @observable sortDirection = 'ascending';
  @observable keyword = '';
  @observable sortColumn = 'LanguageName';
  @observable sortKey = 'LanguageName';
  @observable totalItems = 0;

  @observable curPage = 1;
  @observable pageSize = 20;
  @observable totalPage = 0;

  @observable open = false;
  @observable modalParams = {};

  @action setFieldsValue = obj => {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
    });
  };

  @action fetchAll = (setTotalPage = false) => {
    this.loading = true;
    getAllData(this.keyword, this.filterType, this.curPage, this.pageSize).then(
      action(data => {
        this.loading = false;
        this.data = data;
        this.totalPage = data.sumPage;
        this.totalItems = data.sumItem;
      }),
    );
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchAll();
  };

  @action refetch = (data, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchAll(setTotalPage);
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  @action resetStore = () => {
    this.keyword = '';
    this.sortColumn = 'LanguageName';
    this.sortKey = 'LanguageName';
    this.sortDirection = 'descending';
    this.curPage = 1;
    this.totalPage = 0;
  };
}

export default new Store();
